import React from 'react';

export default class FinishPage extends React.Component {
    render() {
        return (
            <div className="contentMain">
                <div className="elem-status-step">
                    <ul className="step-3">
                        <li><span>0</span>1<span>.  内容入力</span></li>
                        <li><span>0</span>2<span>.  内容の確認</span></li>
                        <li><span>0</span>3<span>.  送信完了</span></li>
                    </ul>
                </div>
                <div className="form-horizontal">
                    <div className="form-inner">
                        <div className="fff">
                            <div className="elem-paragraph">
                                <div>
                                    <p>お問い合わせ内容を送信完了しました。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
